<template>
  <v-radio-group
    v-model="inputValue"
    :name="schema.fullKey"
    :disabled="schema.disabled"
    :required="schema.required"
    :readonly="schema.readonly"
    :row="alignment"
    :rules="schema.rules"
    :label="schema.label"
    @change="emitInput()"
    @input="emitInput()"
  >
    <v-radio
      v-for="(item, index) in schema.items"
      :key="typeof item === 'string' ? index + 1 : item.key"
      :label="typeof item === 'string' ? item : item.label"
      :value="typeof item === 'string' ? index + 1 : item.key"
    ></v-radio>
    <v-tooltip
      v-if="schema.description && schema.description.length > 0"
      slot="append"
      left
    >
      <v-icon slot="activator">info</v-icon>
      <div class="vjsf-tooltip" v-html="schema.description" />
    </v-tooltip>
  </v-radio-group>
</template>

<script>
export default {
  name: 'RDRadioGroupWidget',
  props: {
    schema: {
      type: Object,
      required: true
    },
    value: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      inputValue: this.value,
      alignment: this.schema.row !== undefined ? this.schema.row : false
    }
  },
  created() {
    if (this.schema.hide) {
      this.$emit('hide', this.schema.hide, this.inputValue)
    }
    if (this.schema.show) {
      this.$emit('show', this.schema.show, this.inputValue)
    }
    if (this.schema.makeReadonly) {
      this.$emit('make-readonly', this.schema.makeReadonly, this.inputValue)
    }
  },
  methods: {
    emitInput: function() {
      this.$emit('inputChange', this.inputValue)
      this.$emit('input', this.inputValue)
      if (this.schema.hide != null) {
        this.$emit('hide', this.schema.hide, this.inputValue)
      }
      if (this.schema.show != null) {
        this.$emit('show', this.schema.show, this.inputValue)
      }
      if (this.schema.makeReadonly) {
        this.$emit('make-readonly', this.schema.makeReadonly, this.inputValue)
      }
    }
  }
}
</script>
